var React = require('react');

function ModifiedInline (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"23 4 23 10 17 10","key":0}),React.createElement("polyline",{"points":"1 20 1 14 7 14","key":1}),React.createElement("path",{"d":"M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15","key":2})]);
}

ModifiedInline.defaultProps = {"className":"svg-icon","aria-hidden":"true","role":"img","focusable":"false","width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = ModifiedInline;

ModifiedInline.default = ModifiedInline;
